import PropTypes from "prop-types";
import {
  isEventSpaceCalendarView,
  isFeedViewImageSpace,
  isFeedViewSpace,
  isMembersSpace,
} from "@/react/helpers/spaceHelpers";
import { useHasSpaceRightSidebar } from "@circle-react/components/Spaces/hooks/useHasSpaceRightSidebar";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import { Container } from "@circle-react-shared/Container";

export const Content = ({ children }) => {
  const hasSpaceRightSidebar = useHasSpaceRightSidebar();
  const { data: space } = useCurrentSpaceContext();
  const isFeedView = isFeedViewSpace(space) || isFeedViewImageSpace(space);

  let maxWidth;

  if (isMembersSpace(space) || isEventSpaceCalendarView(space)) {
    maxWidth = "full";
  } else if (isFeedView && !hasSpaceRightSidebar) {
    maxWidth = "md";
  }

  return <Container maxWidth={maxWidth}>{children}</Container>;
};

Content.propTypes = {
  children: PropTypes.node.isRequired,
};
